/**
 * Actions for dataset.
 * @module /data/dataset/store
 */

import * as datasetCommonStore from './store';
import * as datasetDetailsStore from './details/store';
import * as datasetEditStore from './edit/store';

export const datasetStore = {
  namespaced: true,

  actions: {
    ...datasetCommonStore.actions
  },
  state: {
    ...datasetCommonStore.state()
  },
  getters: {
    ...datasetCommonStore.getters
  },
  mutations: {
    ...datasetCommonStore.mutations
  }
};
export const datasetDetailsStoreConfig = datasetDetailsStore;
export const datasetEditStoreConfig = datasetEditStore;
